var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCareerAndWork = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 73,
  viewBox: "0 0 72 73",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  "aria-label": "Career and work"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Frame"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.5994 13.1V4.1H23.3994V13.1",
  stroke: "url(#paint0_linear_495_42)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.5994 13.1V4.1H23.3994V13.1",
  stroke: "white",
  strokeOpacity: 0.1,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector_2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.7998 31.7989V66C1.7998 67.1046 2.69524 68 3.79981 68H68.1998C69.3044 68 70.1998 67.1046 70.1998 66V31.7989",
  stroke: "url(#paint1_linear_495_42)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.7998 31.7989V66C1.7998 67.1046 2.69524 68 3.79981 68H68.1998C69.3044 68 70.1998 67.1046 70.1998 66V31.7989",
  stroke: "white",
  strokeOpacity: 0.1,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector_3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.9848 43.7L70.1998 31.7989V14H1.7998V31.7989L18.8998 38.6495L30.0148 43.7",
  stroke: "url(#paint2_linear_495_42)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.9848 43.7L70.1998 31.7989V14H1.7998V31.7989L18.8998 38.6495L30.0148 43.7",
  stroke: "white",
  strokeOpacity: 0.1,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector_4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.5 37.6264V49.4389L36 51.53L31.5 49.4389V37.6264H40.5Z",
  stroke: "url(#paint3_linear_495_42)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.5 37.6264V49.4389L36 51.53L31.5 49.4389V37.6264H40.5Z",
  stroke: "white",
  strokeOpacity: 0.1,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_495_42",
  x1: 23.3994,
  y1: 8.18085,
  x2: 58.3743,
  y2: 9.21103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6A4DBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2994A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_495_42",
  x1: 1.7998,
  y1: 48.2135,
  x2: 96.7765,
  y2: 50.1013,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6A4DBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2994A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_495_42",
  x1: 1.7998,
  y1: 27.4668,
  x2: 96.7583,
  y2: 29.7673,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6A4DBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2994A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_495_42",
  x1: 31.5,
  y1: 43.9307,
  x2: 44.0013,
  y2: 44.0158,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6A4DBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2994A"
})))));
export { SvgCareerAndWork as ReactComponent };
export default "data:image/svg+xml;base64,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";